import prod from './config.prod.store';
import dev from './config.dev.store';
import completeProfileReducer from '../reducers/completeProfile.reducer';
import {combineReducers} from 'redux';

let exportedModule;
if (process.env.NODE_ENV === 'production') {
  exportedModule = prod;
} else {
  exportedModule = dev;
}

const rootReducer = combineReducers({
  completeProfile: completeProfileReducer,
});

export default exportedModule;
